import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { LanguageSwitcher } from '@/components';
import { Logo } from '@/components/layout/logo';

/**
 * Layout auth : bandeau haut (logo + langue, option lien connexion signup),
 * formulaire centré sur la page (plus de colonne hero).
 */
const AuthLayout = ({ title, subtitle, children, className = '', showSignInLink = false }) => {
  const { t } = useTranslation();

  return (
    <div className={`min-h-svh flex flex-col bg-white ${className}`}>
      <header className="sticky top-0 z-50 bg-white px-6 py-4">
        <div className={`flex items-center gap-4 ${showSignInLink ? 'justify-between' : 'justify-start'}`}>
          <div className="flex items-center gap-4 min-w-0">
            <Logo width={126} height={33} variant="onboarding" alt={t('common.logo')} />
            <LanguageSwitcher colorScheme="dark" />
          </div>
          {showSignInLink ? (
            <div className="hidden sm:flex text-sm text-gray-600 items-center gap-1.5 flex-wrap justify-end shrink-0">
              <span>{t('auth.layout.signup_already_account')}</span>
              <Link to="/login" className="text-[#20766F] font-medium underline hover:text-[#20766F]/90">
                {t('auth.layout.signup_sign_in')}
              </Link>
            </div>
          ) : null}
        </div>
      </header>

      <main className="flex-1 flex flex-col items-center justify-center px-4 sm:px-6 pt-6 pb-10 sm:py-10 min-h-0 w-full">
        <div className="flex w-full max-w-[415px] flex-1 flex-col sm:block sm:flex-initial">
          {(title || subtitle) && (
            <div className="mb-6 flex flex-col items-center gap-1.5 text-center sm:mb-8">
              {title && (
                <h1
                  className="text-[28px] leading-tight font-bold mb-0"
                  style={{ fontFamily: 'Inter, ui-sans-serif, system-ui' }}
                >
                  {title}
                </h1>
              )}
              {subtitle && <p className="text-sm text-gray-500">{subtitle}</p>}
            </div>
          )}

          <div className="flex min-h-0 flex-1 flex-col sm:block sm:flex-none">
            {children}
          </div>

          {showSignInLink ? (
            <div className="mt-auto border-t border-gray-100 pt-6 text-center text-sm text-gray-600 sm:hidden">
              <span>{t('auth.layout.signup_already_account')}</span>{' '}
              <Link to="/login" className="text-[#20766F] font-medium underline hover:text-[#20766F]/90">
                {t('auth.layout.signup_sign_in')}
              </Link>
            </div>
          ) : null}
        </div>
      </main>
    </div>
  );
};

AuthLayout.propTypes = {
  title: PropTypes.string,
  subtitle: PropTypes.string,
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  showSignInLink: PropTypes.bool,
};

export default AuthLayout;
